import React from "react";
import MainState from "./context/MainContext/MainState";
import ProposalContainer from "./components/ProposalContainer";
import "./ProposalContainer.css";

const App = ()=>{
  return (  
    <MainState>
      <ProposalContainer/>
    </MainState>
  )
}

export default App;

